$(document).ready(function(){
	var form = $('.availabilityForm');
	form.on('submit', function(e){
		e.preventDefault();
		var url = $(this).attr('action') + '?availability=' + $('.filterByAvailability').val();
		var submitVal = form.find('input[type="submit"]').attr('data-value');
		var submitLoading = form.find('input[type="submit"]').attr('data-loading');

		$.ajax({
		  type: 'GET',
		  url: url,
		  dataType: 'html',
		  beforeSend: function(){
		  	form.find('input[type=submit]').val(submitLoading).prop('disabled', true);
		  },
		  success: function(response, statut){
		    $('.articlesList--availableLands').html($(response).find('.articlesList--availableLands').html());
		  },
		  complete: function(response, statut){
		  	form.find('input[type="submit"]').val(submitVal).prop('disabled', false);
		  }
		});
 		// $('.articlesList--availableLands').html().load(url + ' .articlesList--availableLands');
	});

});